const toRecord = (value: unknown): Record<string, unknown> | null => (
  value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null
);

const normalizeBridgeTargetRoute = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return '/school/settings/general';
  }
  return value.startsWith('/super-administrator/control-plane/integrations')
    ? '/school/settings/general'
    : value;
};

export type AssistantSpreadsheetBridgeStatus = {
  connected: boolean;
  statusLabel: string;
  targetRoute: string | null;
  supportedEnvironment: boolean;
  bridgeState: 'connected' | 'not_connected' | 'download_only' | 'needs_attention';
  presets: Array<Record<string, unknown>>;
};

export const buildAssistantBridgeStatus = (payload: unknown): AssistantSpreadsheetBridgeStatus => {
  const root = toRecord(payload);
  const statusLabel = typeof root?.status === 'string' ? root.status : 'unknown';
  const bridgePayload = toRecord(root?.payload) ?? toRecord(root?.data);
  const rawBridgeState = typeof bridgePayload?.bridgeState === 'string' ? bridgePayload.bridgeState : '';
  const supportedEnvironment = bridgePayload?.supportedEnvironment !== false;
  const bridgeState = (
    rawBridgeState === 'connected'
      ? 'connected'
      : rawBridgeState === 'not_connected'
        ? 'not_connected'
        : rawBridgeState === 'download_only'
          ? 'download_only'
          : rawBridgeState === 'needs_attention'
            ? 'needs_attention'
            : supportedEnvironment
              ? (bridgePayload?.connected === true || statusLabel === 'connected' ? 'connected' : 'not_connected')
              : 'download_only'
  );
  const presets = Array.isArray(bridgePayload?.presets)
    ? bridgePayload.presets.filter((entry): entry is Record<string, unknown> => Boolean(toRecord(entry)))
    : [];

  return {
    connected: bridgePayload?.connected === true || bridgeState === 'connected',
    statusLabel: bridgeState === 'connected'
      ? 'connected'
      : bridgeState === 'not_connected' || statusLabel === 'disconnected'
        ? 'not connected'
        : bridgeState === 'download_only'
          ? 'download only'
          : statusLabel === 'missing_prerequisite'
            ? 'needs setup'
            : statusLabel === 'invalid_request'
              ? 'needs attention'
              : statusLabel,
    supportedEnvironment,
    bridgeState,
    presets,
    targetRoute: normalizeBridgeTargetRoute(root?.targetRoute),
  };
};
